<template lang="pug">
#docContainer(v-loading='loading'
  element-loading-text='文档加载中...'
  element-loading-background='rgba(0, 0, 0, 0.5)')
  iframe(ref='iframeID')
  application(ref='docApplication' type="pdf" v-if="docloaded")
</template>

<script>
import { scanUrl, creatWatermarkUserInfo } from "@/CommonDP/mongeView/utils";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import application from "@/views/mongeView/application.vue";
import { viewFile, getToken } from "@/CommonDP/utils";

export default {
  components: { application },
  data() {
    return {
      docloaded: false,
      loading: true,
      loadingTxt: "文档加载中...",
      createUserDept: ""
    };
  },
  computed: {
    docmentData() {
      return JSON.parse(mongeApp.other.fileInfo);
    }
  },
  created () {
    if (!this.$route.query.title) {
      this.getFileInfo();
    }
  },
  mounted() {
    if (this.$route.query.title) {
      this.getRequestData();
    }
  },
  methods: {
    async getFileInfo() {
      const { fileId, versionId: fileVersion, sharerId = "", i = "" } = this.$route.query;
      mongeMutations.setShareId(i);
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const { data } = await mongeService.getFileDetails(fileId, i);
      document.title = data.fileName;
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion
      };
      mongeMutations.setDocmentView(JSON.stringify(urlData));
      await this.getRequestData(sharerId);
    },
    getRequestData(sharerId) {
      window.callBackError = () => {
        this.loadingTxt = "文档加载失败";
      };
      window.callBackSuccess = () => {
        this.loading = false;
        // 添加水印
        const ifreamBox = this.$refs.iframeID;
        const text = creatWatermarkUserInfo();
        ifreamBox.contentWindow.waterMark(text);
        this.docloaded = true;
      };
      this.createUserDept = 1;
      let pdfUrl = '';
      if (this.$route.query.title) {
        // 有title用于帮助手册的预览
        document.title = this.$route.query.title;
        pdfUrl = this.requestTypeHelpManual(this.$route.query.filePath);
      } else {
        const otherData = this.docmentData;
        pdfUrl = scanUrl(otherData.fileId, otherData.fileVersion, sharerId);
      }
      this.$refs.iframeID.src = `./pdf/web/viewer.html?file=${encodeURIComponent(pdfUrl)}#page=${this.createUserDept}`;
    },

    requestTypeHelpManual(filePath) {
      const requestType = viewFile(filePath, getToken());
      return requestType;
    }
  }

};
</script>
<style lang="scss" scoped>
#docContainer{
  width: 100%;
  height: 100%;
  position: relative;
  iframe{
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
